import React, { Fragment } from "react";
import { BRAND } from "../../styles/brand";

export default function CommonLoader({ loading, color }) {
  const brandColor = color || BRAND.primary;
  
  return (
    <Fragment>
      {loading && (
        <div className="loader-overlay">
          <div className="loader-container">
            {/* Main beaker with liquid animation */}
            <div className="beaker-container">
              <div className="beaker">
                <div className="liquid-fill"></div>
                <div className="bubbles">
                  <div className="bubble bubble-1"></div>
                  <div className="bubble bubble-2"></div>
                  <div className="bubble bubble-3"></div>
                  <div className="bubble bubble-4"></div>
                </div>
              </div>
              
              {/* Dropper animation */}
              <div className="dropper">
                <div className="dropper-tip"></div>
                <div className="drop drop-1"></div>
                <div className="drop drop-2"></div>
                <div className="drop drop-3"></div>
              </div>
            </div>
            
            {/* Loading text */}
            <div className="loading-text">
              <span>A</span>
              <span>n</span>
              <span>a</span>
              <span>l</span>
              <span>y</span>
              <span>z</span>
              <span>i</span>
              <span>n</span>
              <span>g</span>
              <span>.</span>
              <span>.</span>
              <span>.</span>
            </div>
          </div>
        </div>
      )}
      
      <style jsx>{`
        .loader-overlay {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(255, 255, 255, 0.7);
          backdrop-filter: blur(3px);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 9999;
        }
        
        .loader-container {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 30px;
        }
        
        .beaker-container {
          position: relative;
          width: 120px;
          height: 140px;
        }
        
        .beaker {
          position: relative;
          width: 90px;
          height: 110px;
          background: linear-gradient(to bottom, transparent 0%, transparent 15%, rgba(0, 125, 209, 0.05) 15%);
          border-left: 4px solid #e0e0e0;
          border-right: 4px solid #e0e0e0;
          border-bottom: 4px solid #e0e0e0;
          border-top: none;
          border-radius: 0 0 15px 15px;
          margin: 0 auto;
          overflow: hidden;
          box-shadow: 
            inset 0 0 20px rgba(0, 125, 209, 0.1),
            0 4px 8px rgba(0, 0, 0, 0.1);
        }
        
        .beaker::before {
          content: '';
          position: absolute;
          top: -4px;
          left: -15px;
          right: -15px;
          height: 12px;
          background: linear-gradient(to bottom, #f0f0f0, #e0e0e0);
          border-radius: 6px 6px 0 0;
          border: 2px solid #d0d0d0;
          border-bottom: none;
        }
        
        .beaker::after {
          content: '';
          position: absolute;
          top: -2px;
          right: -25px;
          width: 20px;
          height: 8px;
          background: linear-gradient(to bottom, #f0f0f0, #e0e0e0);
          border: 2px solid #d0d0d0;
          border-radius: 4px 8px 8px 4px;
          border-left: none;
        }
        
        .liquid-fill {
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          height: 0;
          background: linear-gradient(to top, 
            ${brandColor}, 
            rgba(0, 125, 209, 0.7), 
            rgba(255, 100, 100, 0.3));
          border-radius: 0 0 12px 12px;
          animation: fillBeaker 4s ease-in-out infinite;
          transition: background 0.5s ease;
        }
        
        .bubbles {
          position: absolute;
          width: 100%;
          height: 100%;
        }
        
        .bubble {
          position: absolute;
          background: rgba(255, 255, 255, 0.6);
          border-radius: 50%;
          animation: bubbleRise 2s ease-in-out infinite;
        }
        
        .bubble-1 {
          width: 6px;
          height: 6px;
          left: 20%;
          animation-delay: 0s;
        }
        
        .bubble-2 {
          width: 4px;
          height: 4px;
          left: 60%;
          animation-delay: 0.5s;
        }
        
        .bubble-3 {
          width: 8px;
          height: 8px;
          left: 40%;
          animation-delay: 1s;
        }
        
        .bubble-4 {
          width: 5px;
          height: 5px;
          left: 70%;
          animation-delay: 1.5s;
        }
        
        .dropper {
          position: absolute;
          top: -35px;
          left: 50%;
          transform: translateX(-50%);
          width: 25px;
          height: 50px;
        }
        
        .dropper-tip {
          width: 12px;
          height: 35px;
          background: linear-gradient(to bottom, #666, #444);
          margin: 0 auto;
          border-radius: 0 0 50% 50%;
          position: relative;
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
        }
        
        .dropper-tip::before {
          content: '';
          position: absolute;
          top: -15px;
          left: -8px;
          width: 28px;
          height: 15px;
          background: linear-gradient(to bottom, #888, #666);
          border-radius: 14px 14px 0 0;
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
        }
        
        .dropper-tip::after {
          content: '';
          position: absolute;
          top: -25px;
          left: -6px;
          width: 24px;
          height: 12px;
          background: linear-gradient(to bottom, #aaa, #888);
          border-radius: 12px 12px 0 0;
          border: 1px solid #777;
        }
        
        .drop {
          position: absolute;
          width: 7px;
          height: 10px;
          background: #dc3545;
          border-radius: 50% 50% 50% 50% / 60% 60% 40% 40%;
          left: 50%;
          transform: translateX(-50%);
          animation: dropFall 3s ease-in infinite;
          box-shadow: 0 2px 4px rgba(220, 53, 69, 0.3);
        }
        
        .drop-1 {
          top: 40px;
          animation-delay: 0s;
        }
        
        .drop-2 {
          top: 55px;
          animation-delay: 1s;
        }
        
        .drop-3 {
          top: 70px;
          animation-delay: 2s;
        }
        
        .loading-text {
          font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
          font-size: 18px;
          font-weight: 500;
          color: ${brandColor};
          letter-spacing: 2px;
          display: flex;
          gap: 2px;
        }
        
        .loading-text span {
          animation: textWave 1.5s ease-in-out infinite;
        }
        
        .loading-text span:nth-child(1) { animation-delay: 0s; }
        .loading-text span:nth-child(2) { animation-delay: 0.1s; }
        .loading-text span:nth-child(3) { animation-delay: 0.2s; }
        .loading-text span:nth-child(4) { animation-delay: 0.3s; }
        .loading-text span:nth-child(5) { animation-delay: 0.4s; }
        .loading-text span:nth-child(6) { animation-delay: 0.5s; }
        .loading-text span:nth-child(7) { animation-delay: 0.6s; }
        .loading-text span:nth-child(8) { animation-delay: 0.7s; }
        .loading-text span:nth-child(9) { animation-delay: 0.8s; }
        .loading-text span:nth-child(10) { animation-delay: 0.9s; }
        .loading-text span:nth-child(11) { animation-delay: 1.0s; }
        .loading-text span:nth-child(12) { animation-delay: 1.1s; }
        
        @keyframes fillBeaker {
          0% { 
            height: 15%; 
            background: linear-gradient(to top, ${brandColor}, rgba(0, 125, 209, 0.7));
          }
          25% { 
            height: 35%; 
            background: linear-gradient(to top, ${brandColor}, rgba(0, 125, 209, 0.7), rgba(255, 100, 100, 0.2));
          }
          50% { 
            height: 55%; 
            background: linear-gradient(to top, ${brandColor}, rgba(0, 125, 209, 0.6), rgba(255, 100, 100, 0.4));
          }
          75% { 
            height: 35%; 
            background: linear-gradient(to top, ${brandColor}, rgba(0, 125, 209, 0.7), rgba(255, 100, 100, 0.3));
          }
          100% { 
            height: 15%; 
            background: linear-gradient(to top, ${brandColor}, rgba(0, 125, 209, 0.7));
          }
        }
        
        @keyframes bubbleRise {
          0% {
            bottom: 0;
            opacity: 0;
          }
          50% {
            opacity: 1;
          }
          100% {
            bottom: 80px;
            opacity: 0;
          }
        }
        
        @keyframes dropFall {
          0% {
            opacity: 0;
            transform: translateX(-50%) scale(0.5);
          }
          10% {
            opacity: 1;
            transform: translateX(-50%) scale(1);
          }
          75% {
            opacity: 1;
            transform: translateX(-50%) scale(1);
          }
          85% {
            opacity: 0.8;
            transform: translateX(-50%) translateY(65px) scale(0.3);
          }
          100% {
            opacity: 0;
            transform: translateX(-50%) translateY(70px) scale(0);
          }
        }
        
        @keyframes textWave {
          0%, 100% {
            transform: translateY(0);
            opacity: 0.7;
          }
          50% {
            transform: translateY(-10px);
            opacity: 1;
          }
        }
        
        /* Responsive design */
        @media (max-width: 768px) {
          .beaker-container {
            width: 100px;
            height: 120px;
          }
          
          .beaker {
            width: 70px;
            height: 85px;
          }
          
          .loading-text {
            font-size: 16px;
          }
        }
      `}</style>
    </Fragment>
  );
}